import {
  ONBOARD_EMPLOYEE_INFO_ACTION,
  ONBOARD_EMPLOYEE_VERIFY_ACTION,
  DEDUCTION_LIST_ACTION,
  ONBOARD_EMPLOYEE_VERIFY_GOVT_ACTION,
  ONBOARD_EMPLOYEE_TERMS_ACTION
} from "./types";

export const onBoardEmployeeInfoAction = (data) => ({
  type: ONBOARD_EMPLOYEE_INFO_ACTION,
  payload: data,
});

export const onBoardEmployeeVerifyAction = (data) => ({
  type: ONBOARD_EMPLOYEE_VERIFY_ACTION,
  payload: data,
});

export const getDeductionListAction = () => ({
  type: DEDUCTION_LIST_ACTION,
});

export const onBoardEmployeeVerifyGovtAction = (data) => ({
  type: ONBOARD_EMPLOYEE_VERIFY_GOVT_ACTION,
  payload: data
})

export const onBoardEmployeeTermsAction = (data) => ({
  type: ONBOARD_EMPLOYEE_TERMS_ACTION,
  payload: data,
});